import * as yup from "yup";

import {
    DayOfWeek,
    MonthlyScheduleType,
    RecurrenceType
} from "../../API";
import {
    addDays,
    startOfDay
} from "date-fns";

const REQUIRED_FIELD_TEXT = "Field cannot be empty";

const dailyRecurrenceSchema = yup.object({
    interval: yup.number().min(1).required(REQUIRED_FIELD_TEXT)
});

const weeklyRecurrenceSchema = yup.object({
    interval: yup.number().min(1).required(REQUIRED_FIELD_TEXT),
    daysOfWeek: yup.array().of(yup.mixed<DayOfWeek>()).min(1, "At least one day must be selected").required(REQUIRED_FIELD_TEXT)
});

const monthlyRecurrenceSchema = yup.object({
    interval: yup.number().min(1).required(REQUIRED_FIELD_TEXT),
    type: yup.mixed<MonthlyScheduleType>().required(REQUIRED_FIELD_TEXT),
    dayOfMonth: yup.string().when("type", {
        is: MonthlyScheduleType.DAY_OF_MONTH,
        then: (schema) => schema.matches(/^(L|[1-9]|[12][0-9]|3[01])$/).required(REQUIRED_FIELD_TEXT), // 1-31 or L
    }),
    nthWeekDay: yup.object().when("type", {
        is: MonthlyScheduleType.NTH_WEEK_DAY,
        then: (schema) => schema.shape({
            weekNumber: yup.string().required(REQUIRED_FIELD_TEXT),
            day: yup.mixed<DayOfWeek>().required(REQUIRED_FIELD_TEXT)
        }).required(REQUIRED_FIELD_TEXT)
    })
});

export const assessmentScheduleSchema = yup.object({
    name: yup.string().required(REQUIRED_FIELD_TEXT),
    description: yup.string().optional().nullable(),
    startDate: yup.number().min(0, "Date must be after 1970-01-01").required(REQUIRED_FIELD_TEXT),
    endDate: yup.number().when("startDate", (startDate: number, schema: any) => {
        const dayAfterStartDate = addDays(startOfDay(new Date(startDate)), 1).getTime();
        return schema.min(dayAfterStartDate, "End date must be after start date").optional().nullable();
    }),
    recurrence: yup.object({
        type: yup.mixed<RecurrenceType>().required(REQUIRED_FIELD_TEXT),
        dailyRecurrence: yup.object().when("type", {
            is: RecurrenceType.DAILY,
            then: () => dailyRecurrenceSchema
        }),
        weeklyRecurrence: yup.object().when("type", {
            is: RecurrenceType.WEEKLY,
            then: () => weeklyRecurrenceSchema
        }),
        monthlyRecurrence: yup.object().when("type", {
            is: RecurrenceType.MONTHLY,
            then: () => monthlyRecurrenceSchema
        })
    }).required(REQUIRED_FIELD_TEXT)
});